import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MainFeed from '../components/Feed/MainFeed';
import ProfileLeftSidebar from '../components/Profile/LeftSidebar';
import RightSidebar from '../components/Feed/RightSidebar';
import { useAuth } from '../context/AuthContext'; 
import { useProfileByUsername } from '../hooks/profileQueries';
import { useMediaQuery } from '../hooks/useMediaQuery'; 
import WryvenLoader from '../components/Loaders/WryvenLoader'
import NotFound from "../pages/NotFound";

const CollectionDetailPage = () => {
  const { type, postId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const currentUsername = user?.profile?.username;
  const { data: userData, isLoading } = useProfileByUsername(currentUsername);

  const isDesktop = useMediaQuery('(min-width: 1280px)');

  const handleClose = () => {
    navigate(-1);
  };

  if (isLoading) {
    return <WryvenLoader />;
  }

  if (!userData?.profileID) {
    return <NotFound />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation Bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-white">
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {/* ✅ Custom SVG Back Button */}
            <button
              onClick={handleClose}
              className="w-8 h-8 flex items-center justify-center text-black"
              aria-label="Go back"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
            </button>

            {/* ✅ Dynamic Title - Black and Semibold */}
            <h1 className="text-black font-semibold text-lg capitalize">
              {type === "all" ? "Collections" : `${type}`}
            </h1>
          </div>
        </div>
      </div>

      {/* Main Layout: 
          - pt-14 for mobile to stick to navbar, lg:pt-20 for desktop
          - justify-center to keep content grouped when RightSidebar is hidden
      */}
      <div className="pt-14 sm:pt-20 flex justify-center max-w-7xl mx-auto gap-4 xl:gap-6 px-4 lg:px-6">
        
        {/* Profile Left Sidebar */}
        <div className="hidden lg:block flex-shrink-0 w-[335px] max-w-[335px]">
          <ProfileLeftSidebar userData={userData} />
        </div>

        {/* Main Content: 
            - mt-0 for mobile (snug to navbar), lg:mt-4 for desktop
        */}
        <div className="flex-1 min-w-0 max-w-xl">
          <MainFeed 
            isCollectionDetailView={true}
            username={currentUsername}
            postId={postId}
            profileID={userData.profileID}
            collectionType={type}
          />
        </div>

        {/* Right Sidebar: Conditional mounting stops the API call on mobile/tablet */}
        {isDesktop && (
          <div className="flex-shrink-0 w-80">
            <RightSidebar isVisible={isDesktop} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectionDetailPage;